import WPStagingCommon from '../../wpstg.js';
import 'regenerator-runtime/runtime';
import WPStagingBackup from './wpstg-backup.js';
import * as dom from '../../modules/wpstg-dom-utils';

let WPStagingBackupManageSchedules;

(function($) {
  window.addEventListener('backups-tab', function() {
    WPStagingBackupManageSchedules.listen();
  });

  WPStagingBackupManageSchedules = {
    listen() {
      document.body.addEventListener('click', function(event) {
        if (event.target.id === 'wpstg-manage-backup-schedules') {
          WPStagingBackupManageSchedules.manageSchedulesModal();
        }
      });
      $('body').on('click', '.wpstg--edit-schedule-basic', WPStagingBackupManageSchedules.showAlertForBasic);
    },
    showAlertForBasic(e) {
      WPStagingCommon.resetErrors();
      e.preventDefault();
      alert('Please upgrade to WP Staging Pro to edit existing backup plans. You can delete this plan and create a new one if you want to change it.');
    },
    manageSchedulesModal() {
      WPStagingBackupManageSchedules.fetchSchedules();
      const loaderElement = document.getElementById('wpstg-backup--manage--schedules-loader');

      if (!loaderElement) {
        document.getElementById('wpstg--modal--backup--manage--schedules').innerHTML += '<div id="wpstg-backup--manage--schedules-loader" class="wpstg-loader show-loader"></div>';
      } else {
        loaderElement.classList.add('show-loader');
      }

      WPStagingCommon.getSwalModal(false).fire({
        html: document.getElementById('wpstg--modal--backup--manage--schedules').innerHTML,
        showConfirmButton: false,
        showCloseButton: true,
        showLoaderOnConfirm: false,
        showCancelButton: true,
        cancelButtonText: 'Close',
        confirmButtonText: 'Save',
        width: 750,
        allowEscapeKey: true,
        allowOutsideClick: true,
      });
    },
    fetchSchedules() {
      WPStagingCommon.ajax(
          {
            action: 'wpstg--backups-fetch-schedules',
            accessToken: wpstg.accessToken,
            nonce: wpstg.nonce,
          },
          function(response) {
            dom.qs('.wpstg--swal2-container #wpstg-backup--manage--schedules-loader').classList.remove('show-loader');
            dom.qs('.wpstg--swal2-container #wpstg--modal--backup--manage--schedules--content').innerHTML = response.data;

            document.querySelectorAll('.wpstg--swal2-container #wpstg--modal--backup--manage--schedules--content .wpstg--dismiss-schedule').forEach(function(dismissButton) {
              dismissButton.addEventListener('click', function(event) {
                if (confirm('Do you really want to delete this schedule?')) {
                  WPStagingBackupManageSchedules.dismissSchedule(event.target);
                }
              });
            });
          },
      );
    },
    dismissSchedule(dismissTarget) {
      const scheduleId = dismissTarget.dataset.scheduleId;

      WPStagingCommon.ajax(
          {
            action: 'wpstg--backups-dismiss-schedule',
            accessToken: wpstg.accessToken,
            nonce: wpstg.nonce,
            scheduleId: scheduleId,
          },
          function(response) {
            if (response.success) {
              dom.setLoadingPlaceholder().then(() => dom.loadingPlaceholder());
              WPStagingBackupManageSchedules.fetchSchedules();
              WPStagingBackup.fetchListing();
              WPStagingBackup.modal.create.hasBackupSchedule = false;
            } else {
              WPStagingCommon.showErrorModal(response.data);
              return;
            }
          },
      );
    },
  };
}(jQuery));

export default WPStagingBackupManageSchedules;
